var map = {
	"./_0-COVER-coltrane.jpeg": 6649,
	"./_1-coltrane-sofa.png": 4368,
	"./_10-COVER-coltrane.png": 4065,
	"./_2-coltrane-sofa-34.png": 9567,
	"./_3-coltrane-detalles.png": 5877,
	"./_4-coltrane-ske.png": 5353,
	"./_5-coltrane-detalles.png": 4905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2706;